import { Payor, PayorEnum, PayorType } from 'interfaces';
import { http, HttpResponse } from 'msw';
import { buildPayor } from '../../factories';
import { canonicalPayors } from '../../factories/seeds/entities';

const payorNameMap = {
  BC: PayorEnum.bc,
  MB: PayorEnum.mb,
  MSH: PayorEnum.msh,
  QDOC: PayorEnum.qdoc,
  WCB: PayorEnum.wcb,
  PRIVATE: PayorEnum.private,
  PATIENT: PayorEnum.patient,
} as const;

const payorTypeMap = {
  PUBLIC: PayorType.PUBLIC,
  PRIVATE: PayorType.PRIVATE,
  DIRECT: PayorType.DIRECT,
} as const;

export const mockPayors: Payor[] = canonicalPayors.map((payor) => ({
  ...buildPayor<Payor>(payor),
  name: payorNameMap[payor.name as keyof typeof payorNameMap],
  type: payorTypeMap[payor.type as keyof typeof payorTypeMap],
}));

export const payorMockHandlers = [
  http.get('*/resource/payor/all', () => {
    return HttpResponse.json(mockPayors);
  }),
];
